import request from '@/utils/request';

// 图层树
export async function fetchList() {
    return request({
        url: '/layers-cms/map-layer/get-list',
        method: 'post',
    })
}

export async function fetchParentList() {
    return request({
        url: '/layers-cms/map-layer/getDirList',
        method: 'get',
    })
}


/**
 * 获取云南图层目录树
 */
 export function listLayerTree(data) {
    return request({
      url: '/layer/listLayerTree',
      method: 'get',
      data: data
    });
  }

//获取加载方式
export function layerLoadmode(data) {
  return request({
    url: '/layer/layerLoadmode/list',
    method: 'post',
    data: data
  });
}

// 添加图层
export async function addObj(obj) {
    return request({
        url: '/layers-cms/map-layer/add',
        method: 'post',
        data: obj
    })
}


// 编辑图层
export async function editObj(obj) {
    return request({
        url: '/layers-cms/map-layer/update',
        method: 'post',
        data: obj
    })
}



// 删除图层
export async function delObj(id) {
    return request({
        url: '/layers-cms/map-layer/delete/' + id,
        method: 'post',
    })
}
